module.exports = __webpack_public_path__ + "img/fin.399777ac.svg";